export default [
    {
        cd_cls: 'cd-movie',
        schedule: [
            {
                content: 'Check in',
                time: '14:00'
            },
            {
                content: '项目导向会议',
                time: '15:00'
            },
            {
                content: 'IHD知识体系讲解',
                time: '16:00'
            }
        ]
    },
    {
        cd_cls: 'cd-picture',
        schedule: [
            {
                content: '开幕式',
                time: '8:00'
            },
            {
                content: '导师分配',
                time: '10:00'
            },
            {
                content: '职场商务礼仪',
                time: '14:00'
            },
            {
                content: '多维度体验内容概览',
                time: '15:00'
            },
            {
                content: '香港投资市场介绍及分析',
                time: '16:00'
            },
            {
                content: '香港投资产品及基本投资概念',
                time: '17:00'
            },
            {
                content: '理财金字塔&理财五定律与五原则',
                time: '18:00'
            }
        ]
    },
    {
        cd_cls: 'cd-movie',
        schedule: [
            {
                content: '参观香港贸易发展局',
                time: '8:00'
            },
            {
                content: '商务礼仪深层解读',
                time: '14:00'
            },
            {
                content: '国际资本运作投资',
                time: '16:00'
            },
            {
                content: '工具与资产管理应用',
                time: '18:00'
            }
        ]
    },
    {
        cd_cls: 'cd-location',
        schedule: [
            {
                content: '现金流竞赛',
                time: '9:00'
            },
            {
                content: '商务礼仪进阶',
                time: '14:00'
            },
            {
                content: '基金指标分析全攻略',
                time: '16:00'
            },
            {
                content: '投资组合理论',
                time: '18:00'
            },
        ]
    },
    {
        cd_cls: 'cd-picture',
        schedule: [
            {
                content: '环球资金投资大赛',
                time: '8:00'
            },
            {
                content: '街头问卷实战',
                time: '10:00'
            },
            {
                content: '风险管理',
                time: '14:00'
            },
            {
                content: '境内外医疗融资',
                time: '16:00'
            },
            {
                content: '离岸外汇资产户口',
                time: '18:00'
            }
        ]
    },
    {
        cd_cls: 'cd-location',
        schedule: [
            {
                content: '商业投资策划书演练交流',
                time: '10:00'
            },
            {
                content: '国际跨国企业高层考核',
                time: '12:00'
            },
            {
                content: '策划报告比赛模拟',
                time: '14:00'
            },
            {
                content: '职业潜力学员甄选',
                time: '18:00'
            }
        ]
    },
    {
        cd_cls: 'cd-movie',
        schedule: [
            {
                content: '闭幕仪式',
                time: '8:00'
            },
            {
                content: '颁发实训证明',
                time: '10:00'
            },
            {
                content: '公司高层个人推荐信',
                time: '11:00'
            },
            {
                content: '颁发公司正式实训信',
                time: '12:00'
            },
            {
                content: '职业发展分享沙龙',
                time: '14:00'
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/data/schedule.js